import React from 'react'

export default function RatingLabel(props: {
  text: string
  className?: string
}) {
  const { text, className } = props
  return (
    <div className="text-red-900">
      <p
        className={`mt-4 mb-2 text-xs uppercase text-center text-wrap ${
          className ? className : ''
        }`}
      >
        {text}
      </p>
    </div>
  )
}
